import { BungalowInfo } from 'store/accommodation-slice'
import { CreateReservationRoomDto, GuestDto } from 'store/api-slice/hooks'

export const createBungalows = ({
    guests,
    rooms,
    productId,
    bungalowsBoxId,
}: {
    guests: GuestDto[]
    rooms: CreateReservationRoomDto[]
    productId: string
    bungalowsBoxId: string[]
}) => {
    const bungalowsObjects: BungalowInfo[] = bungalowsBoxId
        .reduce((acc, boxId) => {
            const splitDetails = boxId.split('_')
            if (splitDetails.length === 4) acc.push([...splitDetails, boxId])
            return acc
        }, [] as string[][])
        .map((details) => {
            const [occupancyId, roomId, rateId, bungalowIndex, boxId] = details

            const roomFromCart = rooms.find(
                (room) =>
                    room.occupancyId === occupancyId &&
                    room.roomId === roomId &&
                    room.rateId === rateId
            )
            const { roomName } = roomFromCart || {}

            const guestsForBungalow = guests.filter(
                ({ boxId: guestBoxId }) => guestBoxId === boxId
            )

            const adults = guestsForBungalow
                .filter(({ personType }) => personType === 'adult')
                .map(({ firstName, lastName }) => ({
                    name: firstName || '',
                    surname: lastName || '',
                }))
            const kids = guestsForBungalow
                .filter(({ personType }) => personType === 'kid')
                .map(({ firstName, lastName }) => ({
                    name: firstName || '',
                    surname: lastName || '',
                }))
            const infants = guestsForBungalow
                .filter(({ personType }) => personType === 'infant')
                .map(({ firstName, lastName }) => ({
                    name: firstName || '',
                    surname: lastName || '',
                }))

            return {
                room: {
                    bungalowIndex: +bungalowIndex,
                    occupancyId,
                    roomId,
                    rateId,
                    productId,
                    roomName,
                },
                adults,
                kids,
                infants,
            }
        })

    return bungalowsObjects
}
